<template>
  <div id="main-content" class="add-drop-route">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row style="padding-top: 40px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8"><span class="required-star">* </span><span class="form-lable">{{ $t('common.drop_route_name') }}</span></el-col>
            <input class="input" v-model="drop_route_info.name" type=""/>
            <el-col v-if="error_message.name" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.name" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
<!--          <el-col :span="12" style="display: inline">-->
<!--            <el-col :span="8"><span class="required-star">* </span><span class="form-lable">{{ $t('common.color') }}</span></el-col>-->
<!--            <select class="input" v-model="drop_route_info.color">-->
<!--              <option value="">{{ $t('common.please_select') }}</option>-->
<!--              <option v-for="color in color_list" :key="color.id" :value="color.value">{{ color.value }}</option>-->
<!--            </select>-->
<!--            <el-col v-if="error_message.color" :offset="8" :span="16">-->
<!--              <span v-for="(value, key) in error_message.color" :key="key" class="form-error"> {{ value }}</span>-->
<!--            </el-col>-->
<!--          </el-col>-->
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-row class="row-section">
              <h3>{{ $t('bus_stop.bus_stop_list') }}</h3>
            </el-row>
            <el-row class="row-section">
              <el-button @click="addPlace()" style="float: left; margin-left: 20px" type="success" icon="el-icon-plus"
                         circle></el-button>
              <span style="line-height: 40px;margin-left: 20px;">{{ $t('bus_stop.add_bus_stop') }}</span>
            </el-row>
            <div v-for="(item, index) in drop_route_info.place_list" :key="index">
              <el-row style="padding-bottom: 20px">
                <el-col :span="24" style="display: inline">
                  <div style="display: none" v-if="drop_route_info.place_list[index].id != '-1'">{{ select_model =
                    drop_route_info.place_list[index].id +'|'+index }}
                  </div>
                  <div style="display: none" v-else>{{ select_model = '-1|'+index }}</div>
                  <el-col :span="4">
                    <span class="form-lable">{{ $t('common.bus_stop') }} {{ index+1 }}</span>
                  </el-col>
                  <el-col :span="6">
                    <select style="width: 50%" @change="didSelectPlace" v-model="select_model" class="input">
                      <option :value="'-1|'+index">{{ $t('common.please_select') }}</option>
                      <option v-for="place in sortedPlaceList" :disabled="selected.includes(place.id.toString())"
                              v-bind:key="place.id" :value="place.id+'|'+index">
                        {{ place.name }}
                      </option>
                    </select>
                  </el-col>
<!--                  <el-col :span="4">-->
<!--                    <el-input-number v-if="index" v-model="item.duration" :min="1"></el-input-number>-->
<!--                  </el-col>-->
<!--                  <el-col v-if="index" :span="2">-->
<!--                    <el-button @click="removePlace(index)" style="margin-left: 20px" type="danger" icon="el-icon-minus" circle></el-button>-->
<!--                  </el-col>-->
                  <el-col :span="2">
                    <el-button @click="removePlace(index)" style="margin-left: 20px" type="danger" icon="el-icon-minus" circle></el-button>
                  </el-col>
                  <el-col v-if="error_message.place_list[index].id" :span="8">
                    <span v-for="(value, key) in error_message.place_list[index].id" :key="key" class="form-error"> {{ value }}</span>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "AddDropRoute",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/drop-route?action=back`,
        title: 'route.add_drop_route',
        drop_route_info: {
          name: "",
          color: "",
          place_list: [{id: "-1", duration: 0},{id: "-1", duration: 0}],
          place_ids: "",
        },
        color_list: [
          { id: "red", value: "Red" },
          { id: "blue", value: "Blue" },
          { id: "yellow", value: "Yellow" },
          { id: "green", value: "Green" },
          { id: "lime", value: "LightGreen" },
        ],
        selected: [],
        selectedBus: [],
        error_message: {
          name: [],
          color: "",
          place_list: [ {id: [], isError: false}, {id: [], isError: false} ],
        },
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/drop-route')
          };

          let payload = {
            successCallback,
            data: this.drop_route_info
          }
          this.$store.dispatch('droproute/createDropRoute', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.name = []
        if (this.drop_route_info.name === "") {
          this.error_message.name.push('* ' + this.$t('common.route_name_is_required'))
          check = false
        }

        // this.error_message.color = []
        // if (this.drop_route_info.color === "") {
        //   this.error_message.color.push('* ' + this.$t('route.color_is_required'))
        //   check = false
        // }

        if (this.drop_route_info.place_list.length) {
          for (const [key, value] of Object.entries(this.drop_route_info.place_list)) {
            if (!this.validateList(key, value)) check = false
          }
        }

        return check
      },
      validateList(index, value) {
        index = parseInt(index)
        var check = true
        this.error_message.place_list[index].id = []
        if (value.id === "-1") {
          check = false
          this.error_message.place_list[index].id.push('* ' + this.$t('route.please_select_bus_stop'))
        }
        if (index === 0) {
          if (value.id != "-1" && !this.placeList[this.placeList.findIndex(x => x.id == value.id)].is_school) {
            this.error_message.place_list[index].id.push('* ' + this.$t('route.first_bus_stop_must_be_school'))
          }
        }

        if (index === this.error_message.place_list.length - 1) {
          if (value.id != "-1" && !this.placeList[this.placeList.findIndex(x => x.id == value.id)].is_parking) {
            this.error_message.place_list[index].id.push('* ' + this.$t('route.last_bus_stop_must_be_parking_lot'))
          }
        }

        // if (index && !value.duration) {
        //   check = false
        //   this.error_message.place_list[index].id.push('* ' + this.$t('route.please_input_duration_time'))
        // }

        this.error_message.place_list[index].isError = !check
        return check
      },
      addPlace: function () {
        this.drop_route_info.place_list.push({id: "-1"})
        this.error_message.place_list.push({id: [], isError: false})
      },
      addBus: function () {
        this.drop_route_info.bus_list.push({id: ""})
      },
      removePlace(index) {
        this.selected.splice(index, 1)
        this.drop_route_info.place_list.splice(index, 1)
      },
      removeBus(index) {
        this.selectedBus.splice(index, 1)
        this.drop_route_info.bus_list.splice(index, 1)
      },
      didSelectPlace: function (e) {
        var selectData = e.target.value.split('|')

        this.drop_route_info.place_list[selectData[1]].id = selectData[0]
        this.selected[selectData[1]] = selectData[0]
      },
      didSelectBus: function (e) {
        var selectData = e.target.value.split('|')

        this.drop_route_info.bus_list[selectData[1]].id = selectData[0]
        this.selectedBus[selectData[1]] = selectData[0]
      },
    },
    mounted: function () {
      this.$store.dispatch('bus/retrieveBusList', {})
      this.$store.dispatch('place/retrievePlaceList', {})
    },
    computed: {
      ...mapState('bus', ['busList']),
      ...mapState('place', ['placeList']),
      sortedPlaceList: function () {
        let sortedPlaceList = [].concat(this.placeList)

        sortedPlaceList.sort((before, after) => {
          return before.name < after.name ? -1 : before.name > after.name ? 1 : 0
        })

        return sortedPlaceList
      }
    }
  }
</script>

<style lang="scss">
  .add-drop-route .color-picker,
  .edit-drop-route .color-picker {
    width: 60%;
  }
</style>
